<template>
  <ProductsMob :listTitle="listTitle" :content="content"/>
</template>

<script>
export default {
  data () {
    return {
      listTitle: '云文档系统',
      content: '<div style="font-size:16px;text-indent:2em;">dpiCloud 是一款私有云办公文件存储管理系统，功能包括云端上传、下载，自动同步，自动备份等。</div><br /><div style="font-size:16px;text-indent:2em;padding-top:10px;">能有效保障文件安全性、一致性，单一账号多机同步共享有效提高工作效率。</div><img src="../products/5ba206764151f.png" style="width:300px;height:200px;margin:10px 20px;">'
    }
  }
}
</script>
